module.exports = __webpack_public_path__ + "static/media/icon-eye.adc7bf21.svg";